import { useState, type FormEvent } from 'react';
import { api, ApiError } from '@/api/client';
import { setSession } from '@/auth/session';
import { Callout } from '@/components/Callout';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      setSession(await api.login(email, password));
      // No navigate() call: App re-renders from the session subscription and swaps routes.
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : 'Could not reach the control plane. Is the API running on :5080?',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <form className="card login-card" onSubmit={handleSubmit}>
        <h1 className="t-display" style={{ margin: '0 0 4px' }}>
          Anyware Control Plane
        </h1>
        <p className="t-body muted" style={{ margin: '0 0 24px' }}>
          Sign in to run tenants, money, messaging and servers across every environment.
        </p>

        {error && (
          <div style={{ marginBottom: 16 }}>
            <Callout tone="error">{error}</Callout>
          </div>
        )}

        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            className="input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button className="btn btn-primary" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? <span className="spinner" aria-label="Signing in" /> : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
